export default __webpack_public_path__ + "static/SamsungOne-500-87e8c48cf9f9fc4f5eaac6131c533a83.ttf";